import React from 'react';

import {CompetitorsName} from '@modules/events/views/common/CompetitorsName';
import {CompetitorsAndTypeWrapper} from '@utils/CompetitorsAndTypeWrapper';
import {EventContentType} from '@modules/events/views/common/EventContentType';

import {
    buildEventIdPopupRow,
    buildMatchIdPopupRow,
    buildNotesPopupRow,
    buildPropertyLicencePopupRow,
    buildStageIdPopupRow,
    renderEventSecondLine,
    renderEventThirdLine,
    renderFirstLinePopup,
    renderIdWithCopyIcon,
} from './renderEventContentShared';

/**
 *
 * @param row
 * @returns {[null,null,null]}
 */
export const renderContent = (row) => ([
    renderContentFirstLine(row),
    renderContentSecondLine(row),
    renderContentThirdLine(row),
]);

/**
 *
 * @param row
 * @returns {XML}
 */
const renderContentFirstLine = (row) => {
    /**
     * <div> tag is necessary because of param in Semantic UI <Popup> component (trigger property)
     */
    const contentToRender = (
        <div>
            <CompetitorsAndTypeWrapper>
                <CompetitorsName event={row} />
                <EventContentType event={row} />
            </CompetitorsAndTypeWrapper>
        </div>
    );

    let rows = [
        buildPropertyLicencePopupRow(row, {coalesceLicensorName: false}),
        buildNotesPopupRow(row),
        {
            header: 'Main event content',
            body: row.event_content_is_main_content ? 'Yes' : 'No',
        },
        {
            header: 'Event content ID',
            body: renderIdWithCopyIcon(row.event_content_id),
        },
        buildEventIdPopupRow(row),
        buildMatchIdPopupRow(row),
        buildStageIdPopupRow(row),
    ];

    return renderFirstLinePopup({
        rowId: row.id,
        keyPrefix: 'first-line',
        trigger: contentToRender,
        rows,
    });
};

/**
 *
 * @param row
 * @returns {XML}
 */
const renderContentSecondLine = (row) => renderEventSecondLine(row, row.id, 'avatarTournamentCategory_');

/**
 *
 * @param row
 * @returns {(XML|null)}
 */
const renderContentThirdLine = (row) => {
    return renderEventThirdLine(row, {
        keyPrefix: 'description',
        requireNonEmptyDescription: false,
    });
};
